export const fonts = {
  jumboXxLarge: "Inter",
  jumboXLarge: "Inter",
  jumboLarge: "Inter",
  jumboMedium: "Inter",
  jumboSmall: "Inter",
  headingXxLarge: "Inter",
  headingXLarge: "Inter",
  headingLarge: "Inter",
  headingMedium: "Inter",
  headingSmall: "Inter",
  headingXSmall: "Inter",
  bodyXLargeRegular: "Inter",
  bodyXLargeStrong: "Inter",
  bodyXLargeRegularStrikethrough: "Inter",
  bodyXLargeStrongStrikethrough: "Inter",
  bodyLargeRegular: "Inter",
  bodyLargeStrong: "Inter",
  bodyLargeRegularStrikethrough: "Inter",
  bodyLargeStrongStrikethrough: "Inter",
  bodyMediumRegular: "Inter",
  bodyMediumStrong: "Inter",
  bodyMediumRegularStrikethrough: "Inter",
  bodyMediumStrongStrikethrough: "Inter",
  bodySmallRegular: "Inter",
  bodySmallStrong: "Inter",
  bodySmallRegularStrikethrough: "Inter",
  bodySmallStrongStrikethrough: "Inter",
  bodyXSmallRegular: "Inter",
  bodyXSmallStrong: "Inter",
  bodyXSmallRegularStrikethrough: "Inter",
  bodyXSmallStrongStrikethrough: "Inter",
  buttonLargeRegular: "Inter",
  buttonLargeStrong: "Inter",
  buttonMediumRegular: "Inter",
  buttonMediumStrong: "Inter",
  buttonSmallRegular: "Inter",
  buttonSmallStrong: "Inter",
  buttonXSmallRegular: "Inter",
  buttonXSmallStrong: "Inter",
  metadataMedium: "Roboto Condensed",
  metadataSmall: "Roboto Condensed",
  labelMedium: "Roboto Condensed",
  labelSmall: "Roboto Condensed",
  labelXSmall: "Roboto Condensed",
};

export const colors = {
  brandSecondaryDefault: "#2B2F51",
  brandSecondaryTint: "#808297",
  brandSecondaryShade: "#111320",
  brandGradientDefault: "linear-gradient(125deg, #1F1AFE 0%, #183495 100%)",
  brandGradientColorStopsStart: "#1F1AFE",
  brandGradientColorStopsEnd: "#183495",
  productColorsSecondaryL5: "#bfc1cb",
  productColorsSecondaryL4: "#808297",
  productColorsSecondaryL3: "#6b6d85",
  productColorsSecondaryL2: "#555974",
  productColorsSecondaryL1: "#404462",
  productColorsSecondary: "#2B2F51",
  productColorsSecondaryD1: "#272a49",
  productColorsSecondaryD2: "#222641",
  productColorsSecondaryD3: "#1e2139",
  productColorsSecondaryD4: "#111320",
  contentBrandSecondary: "#808297",
  backgroundBase: "#111320",
  backgroundSurface: "#1e2139",
  backgroundLayer: "#2B2F51",
  backgroundActive: "#183495",
  backgroundGradientSurfaceFadeEnd: "linear-gradient(90deg, #0a0a0a00 0%, #1e2139 100%)",
  backgroundGradientSurfaceFadeBottom: "linear-gradient(180deg, #0a0a0a00 0%, #1e2139 100%)",
  backgroundGradientColorStopsEnd: "#1e2139",
  borderDefault: "#272a49",
  borderSubtle: "#222641",
  borderActive: "#1F1AFE",
  componentButtonTransparentContentActive: "#011638",
  componentButtonTransparentContentDisabled: "#969DA3",
  componentButtonTransparentBackgroundBase: "#ffffff1a",
  componentButtonTransparentBackgroundHover: "#ffffff33",
  componentButtonTransparentBackgroundActive: "#FFDC2E",
  componentButtonTransparentBackgroundDisabled: "#ffffff0d",
  componentButtonTransparentBorderBase: "#0a0a0a00",
  componentButtonTransparentBorderHover: "#0a0a0a00",
  componentButtonTransparentBorderDisabled: "#0a0a0a00",
  componentSelectionControlBackgroundBase: "#2B2F51",
  componentSelectionControlBackgroundSelected: "#183495",
  componentSelectionControlBackgroundSelectedHover: "#183495",
  componentSelectionControlBackgroundSelectedActive: "#183495",
  componentSelectionControlBorderBase: "#272a49",
  componentSelectionControlBorderSelected: "#1F1AFE",
  componentSelectionControlBorderSelectedHover: "#1F1AFE",
  componentSelectionControlBorderSelectedActive: "#1F1AFE",
  componentDataInputBackgroundBase: "#1e2139",
  componentDataInputBackgroundLayer: "#2B2F51",
  componentDataInputBorderBase: "#272a49",
  componentPillPrimaryContentSelected: "#ffffff",
  componentPillPrimaryContentActive: "#ffffff",
  componentPillPrimaryBackgroundSelected: "#183495",
  componentPillPrimaryBackgroundActive: "#183495",
};

export const text = {
  themeName: "Picks",
};